import {getResource, updateResource} from "./common"
import {v4 as uuidv4} from "uuid"
import {BankSettings} from "./bankSettings"

export type IdentificationTypes = {
	allowedIndividualIdentificationTypes: string[]
	allowedSolePropsIdentificationTypes: string[]
	allowedBusinessIdentificationTypes: string[]
}

export type OrgBankAgreementBankRiskSettings = IdentificationTypes & {
	prohibitedBusinessVerticals: string[] | null
	prohibitedIndividualPhysicalAddress: string[] | null
	individualPhysicalAddressAllowUSOnly: boolean
	prohibitedIndividualCitizenship: string[] | null
	prohibitedSolePropsPhysicalAddress: string[] | null
	solePropsPhysicalAddressAllowUSOnly: boolean
	prohibitedSolePropsCitizenship: string[] | null
	prohibitedBusinessPhysicalAddress: string[] | null
	businessPhysicalAddressAllowUSOnly: boolean
	prohibitedBeneficialOwnerOrOfficerAddress: string[] | null
	beneficialOwnerOrOfficerAddressAllowUSOnly: boolean
	prohibitedBeneficialOwnerOrOfficerCitizenship: string[] | null
	prohibitedCountriesOfOperation: string[] | null
	countriesOfOperationAllowUSOnly: boolean
	isUSPresenceRequired: boolean
}

export type BankAgreementDefaults = {
	type: "bankAgreementDefaults"
	id: string
	attributes: {
		createdAt: Date
		updatedAt: Date
		riskSettings: OrgBankAgreementBankRiskSettings
	}
	relationships?: {
		bank: {
			data: {
				type: "bank"
				id: string
			}
		}
	}
}

export async function get(accessToken: string, bankId?: string) {
	const query = {
		bankId,
	}
	const result = await getResource<BankAgreementDefaults>("bank-agreement-defaults", accessToken, query)
	return result.map((v) => v.data)
}

export async function update(accessToken: string, patch: Partial<OrgBankAgreementBankRiskSettings>, id: string) {
	const result = await updateResource<BankSettings>(`bank-agreement-defaults/${id}`, accessToken, {
		type: "bankAgreementDefaults",
		attributes: {
			riskSettings: {...patch},
			idempotencyKey: uuidv4(),
		},
	})
	return result.map((v) => v.data)
}
